import React from "react";

import StepsListView from "components/views/StepsListView";
import { useGroup } from "api/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import StepLink from "components/views/StepLink";
import Accordion from "components/views/Accordion";

const EngineModelList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { manufacturerid, groupid, iframe = false } = queryString.parse(
    location.search
  );

  const { data } = useGroup(groupid);

  const list =
    data && data.group_types
      ? data.group_types.map((t) => ({
          label: t.name,
          id: t.name,
          key: t.name,
          data: t.data.map((d) => ({ label: d.name, id: d.id })),
          accordionContent: t.data.map((d) => (
            <StepLink
              key={d.id}
              unstyled
              label={d.name}
              to={`/gas_type?manufacturerid=${manufacturerid}&groupid=${groupid}&enginetypeid=${d.id}&iframe=${iframe}`}
            />
          )),
        }))
      : data?.group_types;

  function handleClick(item) {
    navigate(
      `/gas_type?manufacturerid=${manufacturerid}&groupid=${groupid}&enginetypeid=${item.id}&iframe=${iframe}`
    );
  }

  // if there's more than one item we show the accordions
  return data?.group_types?.length > 1 ? (
    <Accordion list={list} />
  ) : (
    // when there's only one item in the list we show its content directly
    <StepsListView list={list?.[0].data || list} onClick={handleClick} />
  );
};

EngineModelList.displayName = "EngineModelList";

export default EngineModelList;
